/**
 * DIEUKYDIEU.TV - STORY MOCK DATASET
 * Pre-configured data for the 5 province topics and their 3-step Modern Web Stories.
 * Under 300 lines rule compliant.
 */

export const STORY_TOPICS_DATA = [
    {
        id: 'hue',
        key: 'card_hue',
        promptKey: 'prompt_hue',
        name: 'Huế',
        prompt: 'Điều kỳ diệu tại Huế',
        colorRGB: '147, 51, 234',
        accentColor: '#9333EA',
        img: 'https://images.unsplash.com/photo-1599707367072-cd6ada2bc375?auto=format&fit=crop&w=800&q=85',
        articleId: 901
    },
    {
        id: 'danang',
        key: 'card_danang',
        promptKey: 'prompt_danang',
        name: 'Đà Nẵng',
        prompt: 'Điều kỳ diệu tại Đà Nẵng',
        colorRGB: '14, 165, 233',
        accentColor: '#0EA5E9',
        img: 'https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?auto=format&fit=crop&w=800&q=85',
        articleId: 901
    },
    {
        id: 'binhdinh',
        key: 'card_binhdinh',
        promptKey: 'prompt_binhdinh',
        name: 'Bình Định',
        prompt: 'Điều kỳ diệu tại Bình Định',
        colorRGB: '245, 158, 11',
        accentColor: '#F59E0B',
        img: 'https://images.unsplash.com/photo-1589308078059-be1415eab4c3?auto=format&fit=crop&w=800&q=85',
        articleId: 901
    },
    {
        id: 'vungtau',
        key: 'card_vungtau',
        promptKey: 'prompt_vungtau',
        name: 'Vũng Tàu',
        prompt: 'Điều kỳ diệu tại Vũng Tàu',
        colorRGB: '37, 99, 235',
        accentColor: '#2563EB',
        img: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=800&q=85',
        articleId: 901
    },
    {
        id: 'bentre',
        key: 'card_bentre',
        promptKey: 'prompt_bentre',
        name: 'Bến Tre',
        prompt: 'Điều kỳ diệu tại Bến Tre',
        colorRGB: '16, 185, 129',
        accentColor: '#10B981',
        img: 'https://images.unsplash.com/photo-1528127269322-539801943592?auto=format&fit=crop&w=800&q=85',
        articleId: 901
    }
];

export const WHY_HUMANITY_URL = 'https://mb.dkn.tv/bai-viet-cua-dai-su-ly-hong-chi/nha-sang-lap-phap-luan-cong-cong-bo-bai-viet-vi-sao-co-nhan-loai.html';

export const WEB_STORIES_DATA = {
    hue: {
        id: 'hue',
        name: 'Huế',
        prompt: 'Điều kỳ diệu tại Huế',
        colorRGB: '147, 51, 234',
        accentColor: '#9333EA',
        targetArticleId: 901,
        targetUrl: WHY_HUMANITY_URL,
        slides: [
            {
                type: 'intro',
                kicker: 'Huế • Cố Đô Trầm Mặc',
                title: 'Điều Kỳ Diệu Bên Dòng Sông Hương',
                desc: 'Nơi mảnh đất cố đô linh thiêng, những câu chuyện hồi sinh kỳ diệu sau bạo bệnh đã được viết nên giữa đời thực bằng đức tin và sự thiện lương.',
                bgImg: 'https://images.unsplash.com/photo-1599707367072-cd6ada2bc375?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'temple_buddhist'
            },
            {
                type: 'story',
                kicker: 'Hồi Sinh Thần Kỳ',
                title: 'Thoát Khỏi Bệnh Nan Y Nhờ Thiện Niệm',
                desc: 'Sau chuỗi ngày bế tắc tưởng chừng gục ngã trước bệnh hiểm nghèo, một người con xứ Huế đã tìm thấy môn tập Chân - Thiện - Nhẫn. Nhờ tu dưỡng tâm tính, điều kỳ diệu đã xuất hiện khiến giới y khoa ngỡ ngàng.',
                bgImg: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'spa'
            },
            {
                type: 'answer',
                kicker: 'Cội Nguồn Sinh Mệnh',
                title: 'Bí Mật Tối Hậu Đằng Sau Mọi Kỳ Tích',
                desc: 'Vì sao giữa nhân thế muôn vàn gian truân, những phép màu ấy lại xuất hiện? Con người từ đâu đến và ý nghĩa chân chính của kiếp nhân sinh là gì?',
                bgImg: 'https://images.unsplash.com/photo-1534447677768-be436bb09401?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'auto_awesome',
                ctaLabel: 'ĐÁP ÁN: VÌ SAO CÓ NHÂN LOẠI'
            }
        ]
    },
    danang: {
        id: 'danang',
        name: 'Đà Nẵng',
        prompt: 'Điều kỳ diệu tại Đà Nẵng',
        colorRGB: '14, 165, 233',
        accentColor: '#0EA5E9',
        targetArticleId: 901,
        targetUrl: WHY_HUMANITY_URL,
        slides: [
            {
                type: 'intro',
                kicker: 'Đà Nẵng • Biển Xanh Mỹ Khê',
                title: 'Bình Minh Trên Biển Mỹ Khê',
                desc: 'Nơi sóng biển rì rào và bờ cát trắng trải dài, phép màu đã lặng lẽ hàn gắn những vết thương lòng tưởng chừng không bao giờ có thể chữa lành.',
                bgImg: 'https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'water'
            },
            {
                type: 'story',
                kicker: 'Gia Đình Hòa Hợp',
                title: 'Gia Đình Tái Sinh Từ Lòng Bao Dung',
                desc: 'Một gia đình từng đối mặt với chia ly và mâu thuẫn dai dẳng đã tìm lại sự ấm áp, tiếng cười hạnh phúc sau khi các thành viên học cách hướng nội và bao dung tha thứ cho nhau.',
                bgImg: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'favorite'
            },
            {
                type: 'answer',
                kicker: 'Mục Đích Đời Người',
                title: 'Khám Phá Đáp Án Chân Chính Của Cuộc Đời',
                desc: 'Khi tâm tính thăng hoa, nghịch cảnh biến thành phúc lành. Nhưng nguồn cội của vũ trụ và mục đích con người tồn tại là gì?',
                bgImg: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'auto_awesome',
                ctaLabel: 'ĐÁP ÁN: VÌ SAO CÓ NHÂN LOẠI'
            }
        ]
    },
    binhdinh: {
        id: 'binhdinh',
        name: 'Bình Định',
        prompt: 'Điều kỳ diệu tại Bình Định',
        colorRGB: '245, 158, 11',
        accentColor: '#F59E0B',
        targetArticleId: 901,
        targetUrl: WHY_HUMANITY_URL,
        slides: [
            {
                type: 'intro',
                kicker: 'Bình Định • Đất Võ Hào Khí',
                title: 'Điều Kỳ Diệu Giữa Nắng Gió Eo Gió',
                desc: 'Nơi sóng biển vỗ vào vách đá ngút ngàn, một câu chuyện phi thường về nghị lực và sự che chở thần kỳ đã chạm đến trái tim biết bao người.',
                bgImg: 'https://images.unsplash.com/photo-1589308078059-be1415eab4c3?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'landscape'
            },
            {
                type: 'story',
                kicker: 'Ý Chí Kiên Cường',
                title: 'Vượt Qua Lưỡi Hái Tử Thần Ngoạn Mục',
                desc: 'Sau một tai nạn lao động nghiêm trọng ngỡ như không thể qua khỏi, người đàn ông đất võ đã hồi phục nhanh chóng nhờ giữ trọn thiện niệm và niềm tin kiên định vào những giá trị cao quý.',
                bgImg: 'https://images.unsplash.com/photo-1518837695005-2083093ee35b?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'shield'
            },
            {
                type: 'answer',
                kicker: 'Quy Luật Nhân Quả',
                title: 'Thấu Hiểu Cội Nguồn Mọi Phúc Họa',
                desc: 'Sinh mệnh con người có mối liên hệ mật thiết với thiên lý của vũ trụ. Vì sao nhân loại được sinh ra giữa cõi hồng trần?',
                bgImg: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'auto_awesome',
                ctaLabel: 'ĐÁP ÁN: VÌ SAO CÓ NHÂN LOẠI'
            }
        ]
    },
    vungtau: {
        id: 'vungtau',
        name: 'Vũng Tàu',
        prompt: 'Điều kỳ diệu tại Vũng Tàu',
        colorRGB: '37, 99, 235',
        accentColor: '#2563EB',
        targetArticleId: 901,
        targetUrl: WHY_HUMANITY_URL,
        slides: [
            {
                type: 'intro',
                kicker: 'Vũng Tàu • Biển Xanh & Hải Đăng',
                title: 'Ánh Sáng Soi Rọi Nơi Đầu Sóng',
                desc: 'Giữa biển khơi mênh mông, ánh sáng của đức tin và chân lý đã soi rọi, dẫn lối cho những mảnh đời lầm lạc tìm về bến đỗ an yên.',
                bgImg: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'wb_twilight'
            },
            {
                type: 'story',
                kicker: 'Tái Sinh Tâm Hồn',
                title: 'Tìm Lại Bản Ngã Giữa Giông Bão Đời',
                desc: 'Từng rơi vào bế tắc tột cùng vì trầm cảm và áp lực nợ nần, một người con xứ biển Vũng Tàu đã tìm lại nụ cười và sức khỏe tráng kiện khi thực hành Chân - Thiện - Nhẫn mỗi ngày.',
                bgImg: 'https://images.unsplash.com/photo-1495616811223-4d98c6e9c869?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'self_improvement'
            },
            {
                type: 'answer',
                kicker: 'Ngọn Hải Đăng Sinh Mệnh',
                title: 'Con Đường Trở Về Nguồn Cội',
                desc: 'Giữa biển mênh mang của cõi trần, câu trả lời thiêng liêng nhất dành cho mọi sinh mệnh đang được mở ra phía trước.',
                bgImg: 'https://images.unsplash.com/photo-1509114397022-ed747cca3f65?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'auto_awesome',
                ctaLabel: 'ĐÁP ÁN: VÌ SAO CÓ NHÂN LOẠI'
            }
        ]
    },
    bentre: {
        id: 'bentre',
        name: 'Bến Tre',
        prompt: 'Điều kỳ diệu tại Bến Tre',
        colorRGB: '16, 185, 129',
        accentColor: '#10B981',
        targetArticleId: 901,
        targetUrl: WHY_HUMANITY_URL,
        slides: [
            {
                type: 'intro',
                kicker: 'Bến Tre • Rặng Dừa Nước Miền Tây',
                title: 'Bình Yên Dưới Rặng Dừa Xanh',
                desc: 'Dưới những tán dừa nước êm đềm soi bóng kênh rạch, câu chuyện về người nông dân chất phác và phúc lành gõ cửa đã làm ấm lòng bao thế hệ.',
                bgImg: 'https://images.unsplash.com/photo-1528127269322-539801943592?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'forest'
            },
            {
                type: 'story',
                kicker: 'Thiện Lương Là Phúc',
                title: 'Chuyển Biến Tâm Tính Mang Đến Phúc Báo',
                desc: 'Học cách nhẫn nhịn trước thiệt thòi và đối đãi với mọi người bằng lòng từ bi thuần khiết, người nông dân Bến Tre không chỉ dứt sạch bệnh mãn tính mà gia cảnh cũng trở nên hưng thịnh, ấm no.',
                bgImg: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'volunteer_activism'
            },
            {
                type: 'answer',
                kicker: 'Cứu Rỗi & Thức Tỉnh',
                title: 'Thiên Cơ Vì Sao Có Nhân Loại',
                desc: 'Đức dày chở vạn vật, thiện niệm đón phúc lành. Nhưng đâu là bí mật cứu rỗi tối hậu dành cho nhân loại thời mạt thế?',
                bgImg: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=1200&q=85',
                badgeIcon: 'auto_awesome',
                ctaLabel: 'ĐÁP ÁN: VÌ SAO CÓ NHÂN LOẠI'
            }
        ]
    }
};
